@if (messageByType) {
  <div class="maria-button-dialog "
    [class.btn-large]="btnLarge"
    >
    <div class="close-dialog">
      <button
        (click)="closeDialogMessage()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2>Assistente de Saúde</h2>
    @for (message of messageByType.messages; track message) {
      @if (message.type  === 'text') {
        <p [innerHTML]="message.message"></p>
      }
      @if (message.type  === 'button') {
        <button
          (click)="goTo(message.button)" mat-stroked-button class="maria">
          {{ message.button | stringFormat }}
        </button>
      }
    }
  </div>
}
